import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../Redux/hooks/useAuth';
import Header from '../Sections/Header';
import Footer from '../Sections/Footer';
import { Outlet } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import "../assets/css/style.css"
import "../assets/css/animate.min.css"

export function MainOutlet() {
  const location = useLocation()
  const navigate = useNavigate()
  const auth = useAuth()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const ref = params.get('ref')
    if (ref) {
      if (auth.user) navigate('/panel/referral', { replace: true })
      else navigate(`/signup?ref=${encodeURIComponent(ref)}`, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])
  return (
    <>
      <Header />
      <Outlet />
      <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
      />
      <Footer />
    </>
  )
}
